import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  private storedRoutes = new Map<string, DetachedRouteHandle>();

  // Routes that should be reused (preserved when navigating away)
  private readonly reusableRoutes = [
    '/examination-treatment/test-list',
    '/examination-treatment/form-medical-imaging',
    '/examination-treatment/form-surgery-procedure',
    '/system/locations/sample-list',
  ];

  // Route prefixes - preserve all routes starting with these paths
  private readonly reusableRoutePrefixes = [
    '/examination-treatment',
    '/system/locations',
  ];

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    const fullPath = this.getFullPath(route);

    // Check specific routes
    const matchesSpecificRoute = this.reusableRoutes.some(path => fullPath.includes(path));

    // Check route prefixes (preserve all routes in these modules)
    const matchesPrefix = this.reusableRoutePrefixes.some(prefix => fullPath.startsWith(prefix));

    return matchesSpecificRoute || matchesPrefix;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    if (handle) {
      const fullPath = this.getFullPath(route);
      this.storedRoutes.set(fullPath, handle);
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const fullPath = this.getFullPath(route);
    return this.storedRoutes.has(fullPath);
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const fullPath = this.getFullPath(route);
    return this.storedRoutes.get(fullPath) || null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  private getFullPath(route: ActivatedRouteSnapshot): string {
    const parts: string[] = [];
    let current: ActivatedRouteSnapshot | null = route;

    while (current) {
      if (current.routeConfig?.path) {
        parts.unshift(current.routeConfig.path);
      }
      current = current.parent;
    }

    return '/' + parts.join('/');
  }

  // Method to clear stored routes when needed (e.g., on logout)
  public clearStoredRoutes(): void {
    this.storedRoutes.clear();
  }
}
